import { getUserFriendlyError } from "@common/errorHandler";
import { BaseUrl } from "@config/api";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";

interface SecurityGroup {
  id: number;
  groupName: string;
}

interface SecurityGroupsState {
  securityGroups: SecurityGroup[];
  loading: boolean;
  error: string | null;
}

const initialState: SecurityGroupsState = {
  securityGroups: [],
  loading: false,
  error: null,
};


export const fetchSecurityGroups = createAsyncThunk<SecurityGroup[]>(
  "securityGroups/fetchSecurityGroups",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BaseUrl}/api/auth/user/loggedInUserSecurityGroups`);

      if (response.data.success) {
        return response.data.data as SecurityGroup[];
      } else {
        return rejectWithValue(
          response.data.message || "Failed to fetch security groups"
        );
      }
    } catch (error: any) {
      return rejectWithValue(getUserFriendlyError(error));
    }
  }
);

const securityGroupsSlice = createSlice({
  name: "securityGroups",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSecurityGroups.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchSecurityGroups.fulfilled,
        (state, action: PayloadAction<SecurityGroup[]>) => {
          state.loading = false;
          state.securityGroups = action.payload;
        }
      )
      .addCase(
        fetchSecurityGroups.rejected,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload;
          state.securityGroups = [];
        }
      );
  },
});

export default securityGroupsSlice.reducer;
